export default __webpack_public_path__ + "static/vishnu-0981c3a5b30a84fd3aabbe9fdb39e0f3.png";